module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/WhyNeedSection/cashless-services-88066886578c7bf26fb7e42b97449932.png";